import { render, staticRenderFns } from "./NoticeFooter.vue?vue&type=template&id=5e938b08&scoped=true&"
import script from "./NoticeFooter.vue?vue&type=script&lang=js&"
export * from "./NoticeFooter.vue?vue&type=script&lang=js&"
import style0 from "./NoticeFooter.vue?vue&type=style&index=0&id=5e938b08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e938b08",
  null
  
)

export default component.exports